const CLOUD_PATHS_KEY = "jw_desktop_v2_cloud_book_paths";

function readCloudPaths(): Record<string, string> {
  if (typeof localStorage === "undefined") return {};
  try {
    const raw = localStorage.getItem(CLOUD_PATHS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    const out: Record<string, string> = {};
    for (const [id, p] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof p === "string" && p.trim()) out[id] = p.trim();
    }
    return out;
  } catch {
    return {};
  }
}

/** Remember which local `.sbk` is linked to a cloud/library book id (offline cache). */
export function rememberCloudBookLocalPath(cloudBookId: string, localFilePath: string): void {
  if (typeof localStorage === "undefined") return;
  const id = cloudBookId.trim();
  const fp = localFilePath.trim();
  if (!id || !fp) return;
  const paths = readCloudPaths();
  paths[id] = fp;
  localStorage.setItem(CLOUD_PATHS_KEY, JSON.stringify(paths));
}

export function getCachedCloudBookLocalPath(cloudBookId: string): string | null {
  const id = cloudBookId.trim();
  if (!id) return null;
  return readCloudPaths()[id] ?? null;
}
